import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyAXyTbCXFkDaV2NHj9s9zUShiomLjNJh2Y",
    authDomain: "challenge-efbd5.firebaseapp.com",
    databaseURL: "https://challenge-efbd5.firebaseio.com",
    projectId: "challenge-efbd5",
    storageBucket: "challenge-efbd5.appspot.com",
    messagingSenderId: "136256735530",
    appId: "1:136256735530:web:79f75ca1e2fb80d0e2f653",
    measurementId: "G-P14L890Q7G"
  };
  // Initialize Firebase
 const firebaseApp = firebase.initializeApp(firebaseConfig);
  //firebase.analytics();

  const db = firebaseApp.firestore();
  const auth = firebase.auth();

  export { db, auth };